/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SpecTemplateParagraphIs, SpecTemplateTextIs } from '@gh/builder-shared-data';
import {
  AbstractSnapshotFormComponent,
  EnumDictionary,
  FormState,
  FormStateBuilder,
  FormStateSnapshot,
  getRouteInitData,
  whenCreateOrEditMode,
} from '@gh/common-shared';
import { assign } from 'lodash';
import { JstSectionInfo } from '../../../resources/job-spec-template.model';

@Component({
  standalone: false,
  selector: 'gh-jst-section-form',
  templateUrl: 'jst-section-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JstSectionFormComponent extends AbstractSnapshotFormComponent<JstSectionInfo> implements OnInit {
  sectionIsDict: EnumDictionary<SpecTemplateParagraphIs>;
  textIsDict: EnumDictionary<SpecTemplateTextIs>;

  constructor(private route: ActivatedRoute,
              private formStateBuilder: FormStateBuilder) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    assign(this, getRouteInitData(this.route));
  }

  protected buildForm(snapshot: FormStateSnapshot<JstSectionInfo>): FormState<JstSectionInfo> {
    return this.formStateBuilder.buildPlain({
      mode: this.mode,
      enabled: whenCreateOrEditMode(),
      snapshot,
      children: {
        sectionIs: { required: true },
        name: { required: true },
        textIs: { required: true },
        text: void 0,
        isTextWarning: void 0,
      },
    });
  }
}
